import type { ContentObjectView, GivingContentObjectList } from 'models';
import { Col, Row } from 'ui';
import { ContentObjectFooter } from '../../content-object-footer';
import { ContentObjectHeader } from '../../content-object-header';
import { ContentObjectPreview } from '../../content-object-preview';
import { GivingContentObjectBody } from './giving-content-object-body';
import { useCreateActions } from './hooks';

type P = {
  item: GivingContentObjectList;
  onShowComments?: () => void;
  view: ContentObjectView;
};

const GivingContentObject = ({ item, onShowComments, view }: P) => {
  const { actions, contexts } = useCreateActions({ item, view });

  return (
    <Row gutter={[0, 'ms']}>
      <Col span={24}>
        <ContentObjectHeader actions={actions} item={item} view={view} />
      </Col>

      <Col span={24}>
        <GivingContentObjectBody item={item} />
      </Col>

      <Col span={24}>
        <ContentObjectFooter
          item={item}
          onShowComments={onShowComments}
          preview={<ContentObjectPreview item={item} view="other" />}
          view={view}
        />
      </Col>
      {contexts}
    </Row>
  );
};

export default GivingContentObject;
